import { Collapse, Flex, Text } from '@chakra-ui/react'
import { noCoverageOptions } from '@hb/shared'
import { useCallback, useState } from 'react'
import { useField } from 'react-final-form'
import { useForm } from '../../../FinalForm/FormProvider'
import { useFormWizard } from '../../../FormWizard/context'
import { useInsuranceInfoStage } from '../InsuranceInfoStageContext'
import { OptionSelectButtons, SelectedOptionView } from './OptionSelectButton'

export const NoCoverage = () => {
  const { readOnly } = useFormWizard()
  const { insuranceInfoData } = useInsuranceInfoStage()
  const option = insuranceInfoData?.option
  const {
    input: { value },
  } = useField('noCoverageDescription', { subscription: { value: true } })

  const { change, saveWithoutValidation } = useForm()
  const [loadingOption, setLoadingOption] = useState<string | null>(null)

  const onChange = useCallback(
    async (updated: string | null) => {
      change('noCoverageDescription', updated)
      if (!updated) return
      setLoadingOption(updated ?? null)
      await saveWithoutValidation(updated !== null)
      setLoadingOption(null)
    },
    [change, saveWithoutValidation],
  )
  return (
    <Collapse unmountOnExit style={{ width: '100%' }} in={option === 'no-coverage'}>
      <Flex px={1} direction="column" gap={2} py={2}>
        <Text px={1} fontWeight={600} lineHeight={1} fontSize="lg" color="gray.600">
          Please specify:
        </Text>
        {value ? (
          <SelectedOptionView
            selected={value}
            options={noCoverageOptions}
            onEditClick={readOnly ? () => {} : () => onChange(null)}
            loading={!!loadingOption}
          />
        ) : !readOnly ? (
          <OptionSelectButtons
            options={noCoverageOptions}
            onSelectOption={onChange}
            loadingOption={loadingOption}
          />
        ) : null}
        {/* <FormElement name="notPregnantNote" field={notPregnantNote} /> */}
      </Flex>
    </Collapse>
  )
}
